module.exports = __webpack_public_path__ + "img/9791185306544.494ff274.jpg";